import React from 'react';
import { PageSection, SiteData } from '../../../types';
import { isDarkBackground, getOptimalTextColor } from '../../../utils/contrast';

interface SectionProps {
  section: PageSection;
  siteData: SiteData;
}

export const CustomContentSection: React.FC<SectionProps> = ({ section, siteData }) => {
  const content = section.content || {};
  const style = section.style || {};

  const title = content.title || 'Özel İçerik Alanı';
  const description =
    content.description ||
    'Bu alanda dilediğiniz zengin metinleri, duyuruları ve özel açıklamaları yayınlayabilirsiniz.';
  const customHtml = content.customHtml || '';

  const bgColor = style.backgroundColor || '#FFFFFF';
  const isDark = isDarkBackground(bgColor);
  const textColor = style.textColor || getOptimalTextColor(bgColor);

  return (
    <section
      className="py-16 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="max-w-4xl mx-auto space-y-6">
        <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h2>
        {description && (
          <p className="text-sm sm:text-base opacity-80 leading-relaxed">{description}</p>
        )}
        {customHtml && (
          <div
            className={`prose max-w-none pt-4 ${isDark ? 'prose-invert' : 'prose-slate'}`}
            dangerouslySetInnerHTML={{ __html: customHtml }}
          />
        )}
      </div>
    </section>
  );
};
